import { Api } from 'utils';

class ApiIntegrationService {
	
	static finalizeFacebook = async (params?: any) => Api.createResponse('client/api-integration/finalize-facebook',params);
	static finalizeBusinessWhatsapp = async (params?: any) => Api.createResponse('client/api-integration/finalize-whatsapp-business',params);
	static finalizeFacebookBusiness = async (params?: any) => Api.createResponse('client/api-integration/finalize-facebook-business',params);
	static finalizeWhatsapp = async (params?: any) => Api.createResponse('client/api-integration/finalize-whatsapp',params);
	static deleteFacebook = async (params?: any) => Api.createResponse('client/api-integration/delete-facebook',params);
	static deleteInstagram = async (params?: any) => Api.createResponse('client/api-integration/delete-instagram',params);
	static deleteWhatsapp = async (params?: any) => Api.createResponse('client/api-integration/delete-whatsapp',params);
	static deleteTiktok = async (params?: any) => Api.createResponse('client/api-integration/delete-tiktok',params);
	static deleteGoogleCalendar = async (params?: any) => Api.createResponse('client/api-integration/delete-google-calendar',params);
	static connectGoogleCalendar = async (params?: any) => Api.createResponse('client/api-integration/connect-google-calendar',params);

}

export default ApiIntegrationService;